<div class="school-class-compare-block-chart" *ngIf="lineChartData">
  <brt-line-chart [data]="lineChartData" [chartTarget]="chartTarget" *ngIf="hasAnyData; else noDataFound;"></brt-line-chart>

  <ng-template #noDataFound>
    <div class="school-class-compare-block-chart__no-data">
      Noch keine Daten vorhanden
    </div>
  </ng-template>
</div>
